<template>
    <div>
        <b-tabs class="emisiones" v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">Emision</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 0">
                    <factura-emision :emisionrapida="emisionrapida" :emisionrapidaGravada="emisionrapidaGravada" :emisionrapidaIgv="emisionrapidaIgv" @tabindex="changeTab" @identificadorFactura="idEmision"></factura-emision>
                </template>
            </b-tab>
            <b-tab title="Emitidas">
                <template v-if="tabIndex == 1">
                    <factura-consulta :reloadInvoice="reloadInvoice" @itemsfactura="emisionRapidaFactura" @itemsfacturaPadre="itemsContainersPadre" @tabindex="changeTab"></factura-consulta>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">NC Emision</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 2">
                    <nota-credito-factura-emision @tabindex="changeTab"></nota-credito-factura-emision>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6>NC Consulta</h6>
                </template>
                <template v-if="tabIndex == 3">
                    <nota-credito-factura-consulta :reload="reload"></nota-credito-factura-consulta>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">ND Emision</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 4">
                    <nota-debito-factura-emision @tabindex="changeTab"></nota-debito-factura-emision>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6>ND Consulta</h6>
                </template>
                <template v-if="tabIndex == 5">
                    <nota-debito-factura-consulta :reload="reload"></nota-debito-factura-consulta>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Factura Viaje</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 6">
                    <factura-boleto @tabindex="changeTab"></factura-boleto>
                </template>
            </b-tab>
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Factura Hospedaje</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 7">
                    <factura-hospedaje @tabindex="changeTab"></factura-hospedaje>
                </template>
            </b-tab>
            <!-- <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Emision Rapida</h6>
                </template>
                <template v-if="tabIndex == 8">
                    <emision-rapida @tabindex="changeTab"></emision-rapida>
                </template>
            </b-tab> -->
            <b-tab>
                <template slot="title">
                    <h6 class="colorEmision">Emision masiva</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex == 8">
                    <subir-documentos></subir-documentos>
                </template>
            </b-tab>
        </b-tabs>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import FacturaEmision from '@/components/factura/FacturaEmision'
import FacturaConsulta from '@/components/factura/FacturaConsulta'
import NotaCreditoFacturaConsulta from '@/components/notacredito/NotaCreditoFacturaConsulta'
import NotaCreditoFacturaEmision from '@/components/notacredito/NotaCreditoFacturaEmision'
import NotaDebitoFacturaEmision from '@/components/notadebito/NotaDebitoFacturaEmision'
import NotaDebitoFacturaConsulta from '@/components/notadebito/NotaDebitoFacturaConsulta'
import FacturaBoleto from '@/components/factura/FacturaBoleto'
import FacturaHospedaje from '@/components/factura/FacturaHospedaje'
// import EmisionRapida from '@/components/factura/EmisionRapida'
import SubirDocumentos from '@/components/cargamasiva/SubirDocumentos'

export default {
    name: 'Factura',
    components: {
        FacturaEmision,
        FacturaConsulta,
        NotaCreditoFacturaConsulta,
        NotaCreditoFacturaEmision,
        NotaDebitoFacturaEmision,
        NotaDebitoFacturaConsulta,
        FacturaBoleto,
        FacturaHospedaje,
        // EmisionRapida
        SubirDocumentos
    },
    data: () => {
        return {
            tabIndex: 0,
            emitido: false,
            reload: false,
            reloadInvoice: {
               reload: false,
               preview: false 
            },
            emisionrapida: {
                bandera: false,
                itemsrapidos: []
            },
            emisionrapidaGravada:"",
            emisionrapidaIgv:"",            
            idFacturaPreview: ''
        }
    },
    methods: {
        emisionRapidaFactura(value){
            if(value.length > 0){
                this.emisionrapida.bandera = true,
                this.emisionrapida.itemsrapidos = value
            }else{
                this.emisionrapida.bandera = false,
                this.emisionrapida.itemsrapidos = []
            }
        },
        itemsContainersPadre(value){
            if(value.totalVentaGravada !='' && value.montoTotalImpuestos !=''){
                console.log('ENVIADO')
                this.emisionrapidaGravada = value.totalVentaGravada
                this.emisionrapidaIgv = value.montoTotalImpuestos
            }else{
                console.log('NO ENVIO')
                this.emisionrapidaGravada = ""
            }
        },
        changeTab(value){
            this.emitido = true,
            this.tabIndex = value,
            this.emision = this.emitido
        },
        idEmision(value){
            this.idFacturaPreview = value
        }
    },
    watch: {
        // cargaItems: function () {
        //     if(this.items.lenght > 0){
        //         this.emisionrapida = this.items
        //     }else{
        //         this.emisionrapida = []
        //     }
        // },
        tabIndex: function  (){
            if(this.tabIndex == 1 && this.emitido){
                this.reloadInvoice.reload = true
                this.reloadInvoice.preview = this.idFacturaPreview
                this.reload = true
                this.emitido = false
            }else{
                this.reloadInvoice.reload = false
                this.reloadInvoice.preview = false
                this.reload = false
                this.emitido = false
            }
        }
    }
}
</script>

<style>
.colorEmision {
    font-weight: bold;
    color: #00004d;
}
.separador{
    background-color: #ffc12c;
    width: 100%;
    height: 2px
}
.newFunction{
    margin-top: -2%;
    width: 104%;
    margin-left: -2%;
}
.emisiones{
    margin-top: -1%;
}
</style>

